import React from "react";
import { SvgIcon } from "@material-ui/core";

export default function ParameterFilterIcon(props) {
  return (
    <SvgIcon {...props} viewBox="0 0 24 24">
      <path
        d="M4 5h16l-6.5 7.5V19l-3-1.5v-5L4 5z"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.75"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
}
